import HttpService from './HttpService';
export default class SecurityService {
  constructor() {
    this._httpService = new HttpService();
  }

  async findUserCurrent() {
    return await this._httpService.get('/api/security/user/current');
  }

  async getCurrentUser(personType) {
    if (localStorage.getItem('user_current')) {
      let user = await JSON.parse(localStorage.getItem('user_current'));

      // priorizando por persontype
      // if (personType == "PF") {
      //   cpfcnpj = user.cpf;
      //   if (!user.cpf) {
      //     cpfcnpj = user.cnpj;
      //   }
      // }
      // else if (personType == "PJ") {
      //   cpfcnpj = user.cnpj;
      //   if (!user.cnpj) {
      //     cpfcnpj = user.cpf;
      //   }
      // }
      // else {
      //   cpfcnpj = user.cpf ? user.cpf : user.cnpj;
      // }

      return {
        cpfCnpj: (user.cnpj ? user.cnpj : user.cpf),
        email: user.email,
        name: user.name,
        phonePrefix: user.phonePrefix,
        phone: user.phone,
        companyName: user.companyName,
        emailCC: '',
        userId: user.userId,
        quoteId: user.quoteId,
        leadId: user.leadId,
        opportunityId: user.opportunityId,
        accountId: user.accountId
      }
    }
    else {
      return null
    }
  }
}